<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug">
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      domainId: null, //领域
      type: null, //类型
      title: null,
      content: null,
      video: null,
      imgs: [],

      ly_column: [], //领域
      lx_column: [], //类型
    };
  },
  computed: {
    ...mapState(['userInfo','authToken','user_title']),
    view_imgs_url(){
      var vul = [];
      this.imgs.map(r=>{
        vul.push({url:this.$glf.dealImg(r, null)}) 
      });
      return vul;
    },
  },
  watch: {},
  created: function () {},
  mounted: function () {
    this.domainId = this.userInfo.domainId;
    //获取领域
    this.$api.domainPage().then((res) => {
      var ly_data = res.data.data;
      var ly_arr = [];
      ly_data.map(r=>{
        ly_arr.push({
          text: r.name,
          value: r.id
        })
      })
      this.ly_column = ly_arr;
    });
    //获取文章类型
    this.$api.getByType("CMS_ARTICLE_TYPE").then((res) => {
      this.lx_column = res.data;
    });
  },
  methods: {
    //选择领域
    confirmLy(e) {
      this.domainId = e.value.value;
    },
    //选择类型
    confirmLx(e) {
      this.type = e.value.value;
    },
    //上传视频
    afterReadVideo(e) {
      this.$toast.loading({
        message: "上传中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      this.$api.upload({ file: e.file }).then((res) => {
        this.video = res.data;
        this.$toast("上传成功");
      });
    },
    //限制视频大小
    onOversizeVideo(file) {
      this.$toast("视频最大支持50M");
    },
    //限制格式
    beforeReadVideo(file){
      console.log(file);
      if (file.type !== 'video/mp4') {
        this.$toast('视频格式错误，请上传mp4格式的视频。')
        return false;
      }
      return true;
    },
    //删除视频
    removeVideo() {
      this.video = null;
    },

    //上传图片[兼容单图 or 多图]
    async afterReadImages(e) {
      this.$toast.loading({
        message: "上传中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      if(Object.prototype.toString.call(e)==='[object Array]'){
        //多图上传
        for(var i=0;i<e.length;i++){
          await this.$api.upload({ file: e[i].file }).then((res) => {
            this.imgs.push(res.data);
          });
        }
      }else{
        //单图上传
        await this.$api.upload({ file: e.file }).then((res) => {
          this.imgs.push(res.data);
        });
      }
      this.$toast("上传成功");
    },
    //限制图片大小
    onOversizeImages(file) {
      this.$toast("图片最大支持2M");
    },
    //删除图片
    beforeDeleteImages(file, detail) {
      this.imgs.splice(detail.index, 1);
    },
    //格式校验
    beforeReadImages(file){
      var check = true;
      if(Object.prototype.toString.call(file)==='[object Array]'){
        //多图上传
        for(var i=0;i<file.length;i++){
          if (['image/jpeg','image/png','image/gif'].indexOf(file[0].type) === -1) {
            if(check===true){
              check = '第'+(i+1)+'张图片格式错误';
            }
          }
        }
      }else{
        //单图上传
        if (['image/jpeg','image/png','image/gif'].indexOf(file.type) === -1) {
          if(check===true){
            check = '图片格式错误';
          }
        }
      }
      if(check!==true){
        this.$toast(check);
        return false;
      }else{
        return true;
      }
    },

    //发布
    onSub(){
      const {domainId,type,title,content,video,imgs} = this;
      if(this.$glf.isEmpty(domainId)){
        this.$toast('领域不能为空');
        return false;
      }
      if(this.$glf.isEmpty(content)){
        this.$toast('内容不能为空');
        return false;
      }
      // if(this.$glf.isEmpty(video)){
      //   this.$toast('视频不能为空');
      //   return false;
      // }
      if(this.$glf.isEmpty(imgs)){
        this.$toast('图片不能为空');
        return false;
      }
      this.$toast.loading({
        message: "发布中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      var fd = {domainId,type,title,video,content,imgs};
      fd.imgs = JSON.stringify(fd.imgs);
      fd.publishType = 'h5';
      this.$api.articleAdd({article:fd}).then(res=>{
        this.$toast.clear();
        this.$glf.goUrl('push','/sub_res')
      })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/release/index.vue